import { season3Active } from '@/features/points/consts'

export function resolveActivePointsSeason(): 2 | 3 {
  return season3Active ? 3 : 2
}

export function selectSeasonValue<T>(season: number, values: { 2: T; 3: T }): T {
  return season === 3 ? values[3] : values[2]
}
